import React from 'react';
import { Modal, Button, Spin, Space, Descriptions } from 'antd';

const AlertDetailModal = ({ open, onClose, loading, alertId, summary, fields }) => {
  return (
    <Modal
      title={alertId ? `Alert ${alertId}` : 'Alert details'}
      open={open}
      onCancel={onClose}
      footer={<Button onClick={onClose}>Close</Button>}
      width={680}
    >
      {loading ? (
        <Spin />
      ) : (
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          {summary ? (
            <Descriptions size="small" column={1} bordered>
              <Descriptions.Item label="ID">{summary.ID}</Descriptions.Item>
              <Descriptions.Item label="Scope">{summary.scope || '—'}</Descriptions.Item>
              <Descriptions.Item label="Type">{summary.alert_type || '—'}</Descriptions.Item>
              <Descriptions.Item label="Subtype">{summary.alert_subtype || '—'}</Descriptions.Item>
              <Descriptions.Item label="Status">{summary.status}</Descriptions.Item>
            </Descriptions>
          ) : (
            <div style={{ color: '#999' }}>No basic metadata available for this alert.</div>
          )}
          {fields ? (
            <div style={{ fontFamily: 'monospace', fontSize: 12 }}>
              <div>
                Detected fields:{' '}
                {fields.detected_fields?.length
                  ? fields.detected_fields.join(', ')
                  : '—'}
              </div>
              <div>
                Threshold fields:{' '}
                {fields.threshold_fields?.length
                  ? fields.threshold_fields.join(', ')
                  : '—'}
              </div>
              <div>Eligible: {fields.eligible ? 'Yes' : 'No'}</div>
            </div>
          ) : (
            <div style={{ color: '#999' }}>No field coverage data available.</div>
          )}
        </Space>
      )}
    </Modal>
  );
};

export default AlertDetailModal;




